import OnlyHeader from "components/Headers/OnlyHeader";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { participateContest } from "store/actions/contestAction";
import { fetchAllContests } from "store/actions/contestAction";
import { fetchSchoolContests } from "store/actions/contestAction";
import { fetchContestAthletes } from "store/actions/contestAction";
import { updateAthletesStatus } from "store/actions/contestAction";
import { toast } from "react-toastify";
import { suggestAthlete } from "store/actions/athletesAction";
import contestImg from "../assets/img/custom/contestImg.jpg";
import ContestLeaderboard from "components/ContestLeaderboard";
import ContestDetails from "components/ContestDetails";

const tabs = [
  { id: "allContests", name: "All Contests" },
  { id: "acceptedContests", name: "Accepted Contests" },
  { id: "completedContests", name: "Completed Contests" },
];

const Contests = () => {
  let dispatch = useDispatch();
  let { uid, user } = useSelector((state) => state.auth);
  let { contests, contestAthletes, lastVisible, hasMore } = useSelector(
    (state) => state.contest
  );

  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const [athletes, setAthletes] = useState([]);

  const tableHeaders = [
    "Contest Id",
    "Sport",
    "Start Date",
    "End Date",
    "Status",
    "Action",
  ];

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const [activeContest, setActiveContest] = useState(null);
  const [activeContestId, setActiveContestId] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const [athletesModal, setAthletesModal] = useState(false);
  const [isFetchingAthletes, setIsFetchingAthletes] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [leaderboardModal, setLeaderboardModal] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const detailsModalToggler = () => {
    if (detailsModal) {
      setActiveContestId(null);
    }
    setDetailsModal(!detailsModal);
  };

  const handleLeaderboardModalToggle = () => {
    if (leaderboardModal) {
      setActiveContest(null);
    }
    setLeaderboardModal(!leaderboardModal);
  };

  const athletesModalToggler = () => {
    if (athletesModal) {
      setActiveContest(null);
    }
    setAthletesModal(!athletesModal);
  };

  const confirmationModalToggler = () => {
    if (confirmationModal) {
      setActiveContest(null);
    }
    setConfirmationModal(!confirmationModal);
  };

  const formateDate = (firestoreTimestamp) => {
    const jsDate = new Date(
      firestoreTimestamp.seconds * 1000 +
        firestoreTimestamp.nanoseconds / 1000000
    );
    const formattedDate = jsDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return formattedDate.split("/").join("-");
  };

  const initiateParticipate = (contest) => {
    confirmationModalToggler();
    setActiveContest(contest);
  };

  const handleParticipate = () => {
    const payload = {
      contestID: activeContest?.contestID,
      contestId: activeContest?.id,
      sportName: activeContest?.sportName,
      schoolId: user?.id,
      email: user?.email,
      county: user?.county,
      instituteLevel: user?.instituteLevel,
      instituteName: user?.instituteName,
      state: user?.state,
      status: "pending",
    };
    console.log("payload: ", payload);
    setIsUpdating(true);
    dispatch(
      participateContest({
        payload,
        onSuccess: () => confirmationModalToggler(),
      })
    ).finally(() => setIsUpdating(false));
  };

  const handleSelectionChange = (index) => {
    const isCurrentlySuggested = athletes[index]?.isSuggested;
    const limitReached =
      athletes?.filter((item) => item?.status === "accepted")?.length >= 22;

    if (!isCurrentlySuggested && limitReached) {
      toast.error("You have reached the maximum selection limit.");
      return;
    }

    const updatedAthletes = [...athletes];
    updatedAthletes[index].isSuggested = !isCurrentlySuggested;
    setAthletes(updatedAthletes);
  };

  const handleUpdate = () => {
    const updatedAthletesStatus = athletes
      .filter((athlete) => {
        const originalAthlete = contestAthletes.find(
          (a) => a.id === athlete.id
        );
        return (
          originalAthlete && !originalAthlete.isSuggested && athlete.isSuggested
        );
      })
      .map((athlete) => ({
        docId: athlete.id,
        athleteId: athlete.athleteID,
        isSuggested: athlete.isSuggested,
      }));

    if (updatedAthletesStatus.length > 0) {
      let data = {
        athleteData: updatedAthletesStatus,
        collectionId: activeContestId,
        coachId: uid,
        created_at: new Date(),
        coach_data: user,
      };
      setIsUpdating(true);
      dispatch(
        suggestAthlete(data, (res) => {
          if (res == "success") {
            dispatch(
              updateAthletesStatus({
                updatedAthletesStatus,
              })
            )
              .then(() => athletesModalToggler())
              .finally(() => setIsUpdating(false));
          } else {
            setIsUpdating(false);
          }
        })
      );
    } else {
      toast.warning("No roster changes detected.");
    }
  };

  const fetchAthletes = (contestId) => {
    setActiveContestId(contestId);
    setIsFetchingAthletes(true);
    dispatch(
      fetchContestAthletes({
        contestId,
        schoolId: user?.id,
      })
    ).finally(() => setIsFetchingAthletes(false));
  };

  const handleLoadMore = () => {
    setIsLoading(true);
    const action =
      activeTab === tabs[0]?.id
        ? fetchAllContests({ schoolId: user?.id, lastVisible })
        : fetchSchoolContests({
            schoolId: user?.id,
            status: activeTab === tabs[1]?.id ? "accepted" : "completed",
            lastVisible,
          });
    dispatch(action).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (user?.showContests) {
      if (contestAthletes?.length > 0) {
        const updatedContestAthletes = JSON.parse(
          JSON.stringify(contestAthletes)
        );
        setAthletes(updatedContestAthletes);
      } else {
        setAthletes([]);
      }
    }
  }, [contestAthletes]);

  useEffect(() => {
    if (user?.showContests) {
      setIsFetching(true);
      const action =
        activeTab === tabs[0]?.id
          ? fetchAllContests({ schoolId: user?.id })
          : fetchSchoolContests({
              schoolId: user?.id,
              status:
                activeTab === tabs[1]?.id
                  ? ["accepted"]
                  : ["admin action pending", "completed", "rewarded"],
            });
      dispatch(action).finally(() => setIsFetching(false));
    }
  }, [activeTab]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7 mb-5" fluid>
        <h2>
          Your football team starters are those players on your offense who were
          on the field for your team’s first play on offense from scrimmage in
          the semi-final game, and those players on your defense who were on the
          field for your team’s first play on defense from scrimmage in the
          semi-final game. Therefore, your team will submit, after the
          semi-final game, the FHP ID#s of UP TO 22 players. This means that for
          the 4 teams in the two semi-final games, there will be submitted a
          total of 88 FHP ID#s, assuming all 88 starters are each registered at
          FHP.
        </h2>
        <img src={contestImg} alt="" width="100%" className="mb-3" />
        {user?.showContests ? (
          <>
            <div className="my-3 d-flex justify-content-end">
              <a
                target="_blank"
                href="https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/SPORTS_CONTEST_RULES.docx?alt=media&token=36147886-af4e-498c-a0d8-93c3fcf32bc0"
              >
                <Button color="primary">Contest Rules</Button>
              </a>
            </div>
            <Row>
              <div className="col">
                <Card className="shadow overflow-hidden">
                  <CardHeader
                    className="border-0 d-flex align-items-center p-0"
                    style={{
                      overflowX: "auto",
                      "-webkit-overflow-scrolling": "touch",
                      scrollbarWidth: "none",
                    }}
                  >
                    {tabs?.map((tab, index) => (
                      <div
                        key={index}
                        className="mb-0 px-3 px-sm-4 py-3 pointer text-nowrap"
                        style={{
                          borderBottom:
                            activeTab === tab?.id && "3px solid #5E72E4",
                          fontWeight: activeTab === tab?.id && "600",
                        }}
                        onClick={() => handleTabChange(tab?.id)}
                        disabled={isFetching}
                      >
                        {tab?.name}
                      </div>
                    ))}
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        {tableHeaders?.map((header, index) => (
                          <th scope="col" key={index}>
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={tableHeaders?.length} className="py-3">
                            <Spinner
                              color="primary"
                              className="d-flex mx-auto"
                            />
                          </td>
                        </tr>
                      ) : contests?.length > 0 ? (
                        contests?.map((contest, index) => {
                          return (
                            <tr key={index}>
                              <td className="text-capitalize">
                                {contest?.contestID}
                              </td>
                              <td className="text-capitalize">
                                {contest?.sportName}
                              </td>
                              <td>
                                {contest?.startDate
                                  ? formateDate(contest?.startDate)
                                  : "N/A"}
                              </td>
                              <td>
                                {contest?.endDate
                                  ? formateDate(contest?.endDate)
                                  : "N/A"}
                              </td>
                              <td>
                                {activeTab === tabs[0]?.id && (
                                  <div
                                    className={`${
                                      contest?.schoolStatus === "accepted"
                                        ? "bg-success"
                                        : contest?.schoolStatus === "pending"
                                        ? "bg-warning"
                                        : !contest?.schoolStatus
                                        ? "bg-purple"
                                        : "bg-primary"
                                    } rounded-pill py-1 px-3 text-white text-uppercase text-center`}
                                    style={{
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {contest?.schoolStatus ?? "Open"}
                                  </div>
                                )}
                                {activeTab === tabs[1]?.id && (
                                  <div
                                    className="bg-success bg-primary rounded-pill py-1 px-3 text-white text-uppercase text-center"
                                    style={{
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    Accepted
                                  </div>
                                )}
                                {activeTab === tabs[2]?.id && (
                                  <div
                                    className="bg-primary rounded-pill py-1 px-3 text-white text-uppercase text-center"
                                    style={{
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {contest?.status}
                                  </div>
                                )}
                              </td>
                              <td>
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => {
                                    setActiveContestId(contest?.id);
                                    detailsModalToggler();
                                  }}
                                >
                                  View Details
                                </Button>
                                {!contest?.schoolStatus &&
                                  activeTab === tabs[0]?.id && (
                                    <Button
                                      color="primary"
                                      size="sm"
                                      onClick={() =>
                                        initiateParticipate(contest)
                                      }
                                    >
                                      Participate
                                    </Button>
                                  )}
                                {(activeTab === tabs[1]?.id ||
                                  (activeTab === tabs[0]?.id &&
                                    contest?.schoolStatus === "accepted" &&
                                    activeTab !== tabs[2]?.id)) && (
                                  <Button
                                    size="sm"
                                    color="primary"
                                    onClick={() => {
                                      fetchAthletes(contest?.id);
                                      athletesModalToggler();
                                    }}
                                  >
                                    Suggest Athletes
                                  </Button>
                                )}
                                {(contest?.schoolStatus === "completed" ||
                                  contest?.schoolStatus === "rewarded") && (
                                  <Button
                                    size="sm"
                                    color="primary"
                                    onClick={() => {
                                      setActiveContest(contest);
                                      handleLeaderboardModalToggle();
                                    }}
                                  >
                                    Leaderboard
                                  </Button>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={tableHeaders?.length}>
                            <p
                              style={{ fontSize: "15px", fontWeight: 500 }}
                              className="text-center py-3 mb-0"
                            >
                              No Contest
                            </p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {hasMore && (
                    <CardFooter className="text-center">
                      <Button
                        color="primary"
                        onClick={handleLoadMore}
                        style={{ width: "120px" }}
                        disabled={isFetching || isLoading}
                      >
                        {isLoading ? <Spinner size="sm" /> : "Load More"}
                      </Button>
                    </CardFooter>
                  )}
                </Card>
              </div>
            </Row>
          </>
        ) : (
          <>
            <h2 className="text-warning">
              Contest section is currently disabled
            </h2>
            <h3>
              Enable the Contest section in settings to explore and participate
              in exciting challenges and rewards!
            </h3>
          </>
        )}
      </Container>
      <Modal
        isOpen={athletesModal}
        toggle={athletesModalToggler}
        size="lg"
        centered
      >
        <ModalHeader className="border-bottom text-capitalize">
          Athletes
        </ModalHeader>
        <ModalBody>
          {isFetchingAthletes ? (
            <div className="text-center py-3">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <div className="d-flex align-items-center mb-2">
                <p
                  className="mb-0 mr-2"
                  style={{ fontSize: "15px", fontWeight: 500 }}
                >
                  Suggested Athletes:
                </p>
                <h4 className="mb-0">
                  {athletes?.filter((item) => item?.isSuggested)?.length || 0}
                  /22
                </h4>
              </div>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr className="border">
                    <th scope="col">Suggested</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">Email</th>
                  </tr>
                </thead>
                <tbody className="border">
                  {athletes?.length > 0 ? (
                    athletes?.map((athlete, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              type="checkbox"
                              checked={athlete?.isSuggested}
                              disabled={
                                contestAthletes?.find(
                                  (a) => a.id === athlete?.id
                                )?.isSuggested
                              }
                              onChange={() => handleSelectionChange(index)}
                              style={{ width: "15px", height: "15px" }}
                              className="pointer"
                            />
                          </td>
                          <td className="text-capitalize">
                            {athlete?.firstName}
                          </td>
                          <td>{athlete?.lastName}</td>
                          <td>{athlete?.email}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={tableHeaders?.length}>
                        <p
                          style={{ fontSize: "15px", fontWeight: 500 }}
                          className="text-center py-3 mb-0"
                        >
                          No Athlete
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={athletesModalToggler}
            disabled={isUpdating}
          >
            Close
          </Button>
          <Button color="primary" onClick={handleUpdate} disabled={isUpdating}>
            Update
            {isUpdating && <Spinner color="white" size="sm" className="ml-2" />}
          </Button>
        </ModalFooter>
      </Modal>
      <ContestDetails
        showModal={detailsModal}
        handleModalToggle={detailsModalToggler}
        contestId={activeContestId}
      />
      <ContestLeaderboard
        contest={activeContest}
        showModal={leaderboardModal}
        handleModalToggle={handleLeaderboardModalToggle}
      />
      <ConfirmationModal
        isOpen={confirmationModal}
        toggle={confirmationModalToggler}
        onConfirm={handleParticipate}
        isLoading={isUpdating}
        title="Participate Contest"
        message="Are you sure you want to participate in this contest?"
      />
    </>
  );
};

export default Contests;
